import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconJump: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="jump, skip"><path d="M7 19.25L17 19.25" stroke="currentColor" strokeWidth="1.5"/><path d="M15 4.75H21.25V11" stroke="currentColor" strokeWidth="1.5"/><path d="M20.5 5.5C16 9.5 12.5 13.5 12 19" stroke="currentColor" strokeWidth="1.5"/><path d="M1 7C6.5 7 12 12.5385 12 18.9123V19" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconJump;
